export default __webpack_public_path__ + "static/media/list_icon.1d6c1a34.svg";